var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3000 3000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1c0a00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2447.39,568.55H552.7c-187.21,0-339,151.8-339,338.92V2092.53c0,187.21,151.8,338.92,339,338.92H2447.39c187.13,0,338.92-151.71,338.92-338.92V907.47C2786.31,720.35,2634.52,568.55,2447.39,568.55Zm-643,1013.22-526.84,263.29c-60.81,30.45-132.37-13.74-132.37-81.68V1236.71c0-67.94,71.56-112.13,132.37-81.77l526.84,263.38C1871.67,1451.93,1871.67,1548.07,1804.35,1581.77Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.7546dc538e70c9b27d80a44579bc12b8.svg";
export { ForwardRef as ReactComponent };